module.exports = __webpack_public_path__ + "img/tag-1.61701c65.svg";